import { gql } from "@apollo/client";

const PROVIDER_FIELDS = `
  id
  name
  type
  isActive
  website
  documentationUrl
  mainContactName
  mainContactEmail
  mainContactPhone
  contacts {
    id
    providerId
    contactType
    name
    email
  }
  createdAt
  updatedAt
`;

const PROVIDER_CONTACT_FIELDS = `
  id
  providerId
  contactType
  name
  email
`;

export const CREATE_PROVIDER = gql`
  mutation CreateProvider($request: ProviderRequestInput!) {
    createProvider(request: $request) {
      ${PROVIDER_FIELDS}
    }
  }
`;

export const UPDATE_PROVIDER = gql`
  mutation UpdateProvider($id: UUID!, $request: ProviderRequestInput!) {
    updateProvider(id: $id, request: $request) {
      ${PROVIDER_FIELDS}
    }
  }
`;

export const SET_PROVIDER_ACTIVE = gql`
  mutation SetProviderActive($id: UUID!, $isActive: Boolean!) {
    setProviderActive(id: $id, isActive: $isActive) {
      id
      isActive
    }
  }
`;

export const DELETE_PROVIDER = gql`
  mutation DeleteProvider($id: UUID!) {
    deleteProvider(id: $id)
  }
`;

export const CREATE_PROVIDER_CONTACT = gql`
  mutation CreateProviderContact($request: ProviderContactRequestInput!) {
    createProviderContact(request: $request) {
      ${PROVIDER_CONTACT_FIELDS}
    }
  }
`;

export const UPDATE_PROVIDER_CONTACT = gql`
  mutation UpdateProviderContact($id: UUID!, $request: ProviderContactRequestInput!) {
    updateProviderContact(id: $id, request: $request) {
      ${PROVIDER_CONTACT_FIELDS}
    }
  }
`;

export const DELETE_PROVIDER_CONTACT = gql`
  mutation DeleteProviderContact($id: UUID!) {
    deleteProviderContact(id: $id)
  }
`;
